import moment from "moment";
import Repo from "../../Repository/Repo";
import { Toast } from "../components/Toast";

export const userDetails = async (value) => {
  try {
    let { data } = await Repo.vehicle({
      request: {
        method: "saveVehicleRegistration",
        data: {
          company_code: localStorage.getItem("companyCode"),
          date: moment().format("DD-MM-YYYY"),
          vModel: value.vModel,
          vRegistration: value.vRegistration,
          sCNIC: value.sCNIC,
          sContact: value.sContact,
          sFatherName: value.sFatherName,
          cCNIC: value.cCNIC,
          cContact: value.cContact,
          cFatherName: value.cFatherName,
          cAddress: value.cAddress,
          cName: value.cName,
          vChesis: value.vChesis,
          vEngine: value.vEngine,
          sName: value.sName,
          sAddress: value.sAddress,
          vMaker: value.vMaker,
          vColor: value.vColor,
          vAmountWords: value.vAmountWords,
          vAmountNumbers: value.vAmountNumbers,
          commission: value.commission,
          paymentDetails: value.paymentDetails,
          sProfile: value.sProfile,
          cProfile: value.cProfile,
        },
      },
    });
    if (data.response.data.registrationId) {
      Toast("success", "Added Successfully");
    } else {
      Toast("error", "Not Added");
    }
  } catch (err) {
    console.log("err:", err);
    Toast("error", "Error");
  }
};
